<template>
    <tr>
        <td></td>
        <td class="text-left">{{ line.article.number }}</td>
        <td class="text-left">{{ line.article.name }}</td>
       
        <td class="text-center align-middle">
            <input v-if="canEdit"
                 style="width: 200px !important; margin: 0 auto;"
                type="number" 
                class="form-control form-control-sm text-center" 
                v-model="line.booked_quantity"
                :name="'articles[' + index + '][booked_quantity]'" 
                min="0"
                step="0.001"
            >

            <span v-if="!canEdit">
                {{ line.booked_quantity }}
            </span>
        </td>
        <td class="text-center align-middle">
            <template v-if="line.booking_lot_id != null">
                <span>
                    {{ line.booked_quantity_total }}
                </span>
            </template>
        </td>
        <td class="text-center align-middle">
            <input v-if="canEdit"
                style="width: 200px !important; margin: 0 auto;" 
                type="text" 
                class="form-control form-control-sm text-center" 
                placeholder="jj/mm/aaaa" 
                :name="'articles[' + index + '][booked_start_at]'" 
                v-model="line.booked_start_at" 
                :id="'datepicker' + this.uniq"
            >
            <span v-if="!canEdit">
                {{ line.booked_start_at }}
            </span>
        </td>
    
       
        <td class="text-right align-middle" v-if="canEdit">
            <span class="btn btn-sm transparent" @click="emitEventLineDeleted">
                <i class="far fa-trash"></i>
            </span>
        </td>
    </tr>
</template>

<script>
import $ from 'jquery'
import Swal from "sweetalert2";

export default {
    props: ['line' , 'index', 'destroyUrlLine', 'canEdit'],
    data() {
        return {
            uniq : Math.random().toString(36).substr(2, 9),
        }
    },
    methods : {
        parseDate(dateStr) {
            if (!dateStr) return null;
            const [day, month, year] = dateStr.split('/');
            return new Date(year, month - 1, day);
        },
        emitEventLineDeleted: function () {
            Swal.fire({
                title: 'Êtes-vous sûr de supprimer cette ligne ?',
                text: "",
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: 'Annuler',
                confirmButtonColor: '#D15240',
                confirmButtonText: 'Oui, supprimer',
                reverseButtons: true,
                heightAuto: false
            }).then((result) => {
                if (result.value) {
                    this.$emit('line-deleted', {'booking_article_id' : this.line.id})
                }
            })
        }
    },
    mounted(){
        $("#datepicker"  + this.uniq).datepicker({
            format: "dd/mm/yyyy",
            todayBtn: true,
            language: "fr",
            calendarWeeks: true,
            autoclose: true,
            todayHighlight: true,
            clearBtn: false,
            startDate: new Date()
        })

        $("#datepicker"  + this.uniq).change(function() {
            $(this)[0].dispatchEvent(new Event('input'));
        });

  


    }
}

</script>